import { Attribute, Component } from '../../../concepts/objects';
import { Interaction } from '../entities/Physical';

export type EffectRequired = Readonly<{ name: string, duration: number, cascade: boolean }>;
export type EffectParams = Readonly<Record<string, any>>;
export type Effect = EffectRequired & EffectParams;

export interface Pose {
    readonly beingEdited?: boolean;
    readonly beingManipulated?: boolean;
    readonly effects?: Record<string, Effect>;
    readonly isRoot?: boolean;
    readonly mine?: boolean;
    readonly pressed?: boolean;
    readonly selected?: boolean;
    readonly peers?: boolean;
    readonly targeted?: boolean;
    readonly interaction?: Interaction;
}

export const Pose = {
    hasInteraction(subject: Component, type: string, hint?: string) {
        const { interaction } = Pose.get(subject);
        return interaction?.type === type && (!hint || interaction?.hint === hint);
    },
    get(subject: Component) {
        return PoseAttr.get(subject);
    },
    getEffect(subject: Component, name: string) {
        return (PoseAttr.get(subject)?.effects ?? {})[name] ?? null;
    },
    matches(subject: Component, predicate: (pose: Pose) => boolean) {
        return predicate(PoseAttr.get(subject));
    },
    update(subject: Component, patch: Partial<Pose>) {
        PoseAttr.setMaybe(subject, Object.assign({}, PoseAttr.get(subject), patch));
    },
};

export const PoseAttr = new Attribute<Pose>('pose', {});
